<button style="width: 100%;"  [class]="custumer">{{name}}<span class="filter">{{amount}}</span> </button>
